import React, { lazy, Suspense, useEffect, useState } from "react";
import "./GaussianSplatMedia.css";


const GaussianSplatViewer = lazy(() =>
  import("@baba_hadjsaid/3dgsviewer").then((module) => ({
    default: module.GaussianSplatViewer,
  }))
);

const GaussianSplatMedia = ({ asset, className = "", fullScreen = false }) => {
  const [ready, setReady] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setReady(false);
    setError("");
  }, [asset?.src]);

  if (!asset?.src) {
    return (
      <div className={`grid h-full w-full place-items-center bg-black text-xs text-white/70 ${className}`}>
        Gaussian splat source not set
      </div>
    );
  }

  return (
    <div
      className={`project-gsplat-viewer relative h-full w-full overflow-hidden bg-black ${className}`}
      onClick={(event) => event.stopPropagation()}
    >
      <Suspense fallback={null}>
        <GaussianSplatViewer
          src={asset.src}
          fullScreen={fullScreen}
          title={asset.alt || "Project Gaussian splat"}
          showHelp={fullScreen}
          showTitle={fullScreen}
          onReady={() => setReady(true)}
          onError={(viewerError) => {
            setReady(false);
            setError(viewerError instanceof Error ? viewerError.message : String(viewerError));
          }}
        />
      </Suspense>

      {!ready && !error && (
        <div className="pointer-events-none absolute inset-0 z-[5] grid place-items-center bg-black/55 text-center font-mono text-[10px] uppercase tracking-[.1em] text-white/80">
          Loading Gaussian splat…
        </div>
      )}
      {error && (
        <div className="absolute inset-0 z-[6] grid place-items-center bg-black/85 px-5 text-center text-xs text-red-300">
          Unable to render this Gaussian splat: {error}
        </div>
      )}
    </div>
  );
};

export default GaussianSplatMedia;
